import { render, staticRenderFns } from "./Clarifications.vue?vue&type=template&id=3889265a&scoped=true&"
import script from "./Clarifications.vue?vue&type=script&lang=js&"
export * from "./Clarifications.vue?vue&type=script&lang=js&"
import style0 from "./Clarifications.vue?vue&type=style&index=0&id=3889265a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3889265a",
  null
  
)

export default component.exports